import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ProductCard } from "@/components/landing/PromoCards";

export default function AdProductsPanel({ panel, onClose, onOpenProduct, lang }) {
  return (
    <Dialog open={!!panel} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="ddf-adp-dialog" data-testid="ad-products-panel">
        <DialogTitle className="ddf-adp-title" data-testid="ad-products-panel-title">
          {panel?.title}
        </DialogTitle>
        <DialogDescription className="sr-only">Products featured in this banner</DialogDescription>
        <div className="ddf-adp-scroll">
          <div className="ddf-product-grid ddf-adp-grid" data-testid="ad-products-panel-grid">
            {(panel?.items || []).map((item) => (
              <ProductCard key={item.id} item={item} lang={lang} onClick={onOpenProduct} />
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
